import React from 'react'
import { parseBackendDate } from 'services/dates'
import CampaignOptionsTooltip from './CampaignOptionsTooltip'
import { useNewTranslation } from 'hooks/index'
import { theme } from 'theme'
import { CampaignState, CAMPAIGN_STATUS_ENUM } from 'state/campaigns'
import Restricted from 'components/Shared/Permission/Restricted'
import { Payout } from 'components/Shared/Permission/enums'
import { ButtonListContainer } from './style'
import Text from 'particles/Text'
import DateIconText from 'components/Shared/DateIconText'
import Icon from 'components/Icon'
import { CSSProp } from 'particles/themes/styled'
import { RectangleLinkButton } from 'particles/Button/RectangleButton'
import SubmissionDeadlineText from './SubmissionDeadlineText'
import { OVERVIEW_ENUM, setSelectedCampaignReport } from 'state/review'
import { CAMPAIGN_REPORT_ENUM } from 'state/review'
import { useDispatch } from 'react-redux'
interface ButtonListProps {
    campaign: CampaignState | any
    customLayOutStyle?: CSSProp
    tooltipId: string
}

const ButtonList: React.FC<ButtonListProps> = ({ campaign, customLayOutStyle, tooltipId }) => {
    const [newT] = useNewTranslation()
    const dispatch = useDispatch()
    const isCampaignClosed = Boolean(campaign && campaign.status === CAMPAIGN_STATUS_ENUM.CLOSED)
    const { start, end } = campaign.overall_time_window
    const startDate = parseBackendDate(start, campaign.country)
    const endDate = parseBackendDate(end, campaign.country, {
        showTime: false,
        showYear: true,
        addSeconds: -1,
    })

    return (
        <ButtonListContainer className="customStyle" customStyle={customLayOutStyle}>
            <div className="campaign-type-container">
                <div className="campaign-type-icon">
                    {campaign.is_private ? (
                        <Icon.LockIcon color={theme.newColors.neutral500} />
                    ) : (
                        <Icon.LockOpenIcon color={theme.newColors.neutral500} />
                    )}
                </div>

                <Text scale="bodyS400" color="secondary">
                    {campaign.is_private
                        ? newT('card.submission.privateCampaignIndicator', 'Private')
                        : newT('card.submission.publicCampaignIndicator', 'Public')}
                </Text>
                <div style={{ margin: 'auto' }} />
                {!isCampaignClosed && <CampaignOptionsTooltip campaign={campaign} id={tooltipId} />}
            </div>
            <div className="campaign-overall-time-window">
                <DateIconText
                    text={newT('card.submission.campaignStartDate', {
                        startDate,
                    })}
                />
                <DateIconText
                    text={newT('card.submission.campaignEndDate', {
                        endDate,
                    })}
                />
            </div>
            <div className="nav-button-container">
                <RectangleLinkButton
                    form="outlined"
                    size="s"
                    color="neutral"
                    label={newT('button.partiposterProgress')}
                    to={`/submissions/progress?campaign=${campaign.uuid}`}
                    className="width-full"
                />
                <RectangleLinkButton
                    form="outlined"
                    size="s"
                    color="neutral"
                    label={newT('button.trackPerformance', 'Track Performance')}
                    to={`/submissions/review?campaign=${campaign.uuid}&task=${campaign.tasks[0].uuid}&viewType=${OVERVIEW_ENUM.REPORT}&step=&entry=submission_list`}
                    onClick={() => {
                        dispatch(setSelectedCampaignReport(CAMPAIGN_REPORT_ENUM.INDIVIDUAL_PERFORMANCE))
                    }}
                    className="width-full"
                />
                <Restricted permissions={[Payout.DisqualifyPartiposters, Payout.UpdatePayouts, Payout.PayPartiposters]}>
                    <RectangleLinkButton
                        form="outlined"
                        size="s"
                        color="neutral"
                        label={newT('button.updatePayouts')}
                        to={`/submissions/payouts?campaign=${campaign.uuid}`}
                        className="width-full"
                    />
                </Restricted>
            </div>

            <SubmissionDeadlineText start={start} end={end} country={campaign.country} hidden={isCampaignClosed} />
        </ButtonListContainer>
    )
}
export default ButtonList
